// extracted by mini-css-extract-plugin
export default {"airplaneSizingContainer":"Bca-z","narrowOptionButtons":"Cca-z","noOptions":"Dca-z"};